module.exports = __webpack_public_path__ + "static/engineeringStory3-d1d3a874f2807c38c45704e93b6d01de.jpg";